// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Szp6","productName":"Table_productName__wByIx"};